 
import axios from "axios";
import useAuthStore from "../store/useAuthStore";
 
export const apiUrl =
  typeof import.meta !== "undefined"
    ? import.meta.env?.VITE_API_URL || ""
    : "";

const instance = axios.create({
  baseURL: apiUrl,
  timeout: 30_000,
  headers: {
    "Content-Type": "application/json",
  },
});

// -----------------------------------------------------------------------------
// Request
// -----------------------------------------------------------------------------

instance.interceptors.request.use(
  (config) => {
    const { accessToken } = useAuthStore.getState();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// -----------------------------------------------------------------------------
// Response
// -----------------------------------------------------------------------------

instance.interceptors.response.use(
  (response) => {
    // File/blob response
    if (response.config.responseType === "blob") {
      return response;
    }

    return {
      success: true,
      data: response?.data?.data,
      meta: response?.data,
      error: null,
    };
  },

  (error) => {
    const status = error?.response?.status;
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong";

    // Unauthorized / expired session
    if (status === 401) {
      useAuthStore.getState().logout();
 
      window.location.href = "/login";

      return {
        success: false,
        data: null,
        error: "Session expired. Please log in again.",
      };
    }

    // Invalid token
    if (
      status === 403 &&
      (
        errorMessage === "Invalid token" ||
        errorMessage === "Invalid token payload"
      )
    ) {
      useAuthStore.getState().logout();
 
      window.location.href = "/login";

      return {
        success: false,
        data: null,
        error: "Invalid session. Please log in again.",
      };
    }

    // Normal API error / permission error
    return {
      success: false,
      data: null,
      error: errorMessage,
    };
  },
);

export default instance;
 